module.exports = __webpack_public_path__ + "static/media/bell.8e49e8d1.svg";